import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { CloseOutlined } from '@ant-design/icons';
import { Col, Row } from "antd";

function Modal({ reduxOpenState, close, children, props }) {
  const resolvePath = (path, obj) => {
    return path.split(".").reduce(function (prev, curr) {
      return prev ? prev[curr] : null;
    }, obj);
  };

  const showModal = useSelector((state) => resolvePath(reduxOpenState, state));

  return (
    <>
      {showModal && (
        <div className="mobile-modal-wrapper">
          <div className="mobile-modal-container">
            <Row>
              <Col xs={1} md={7}></Col>
              <Col xs={22} md={10}>
                <div>
                  <div className="mobile-modal-content">
                    <div className="absolute full-width">
                      <div className="close-button" onClick={close}><CloseOutlined /></div>
                    </div>
                    <div className="full-height overflow-y">
                      {children}
                      <div className="button-wrapper">
                        <button className="button-close" onClick={close}>Schliessen</button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={1} md={7}></Col>
            </Row>
          </div>
        </div>
      )}
      {!showModal && null}
    </>
  );
}

export default Modal;
